import { createContext } from "react";

const CommissionContext = createContext();

export default CommissionContext;